import { t as c } from "./isDefined-fMi6eQ4r.js";
import { t as j } from "./theme-B90C-74v.js";
import { n as y, t as F } from "./linkifyText-BINRNP9w.js";
import { t as U } from "./mergeClassNames-BHKm1BNi.js";
import { clsx as R } from "clsx";
import { Fragment as M, jsx as r, jsxs as N } from "react/jsx-runtime";
import { isNonEmptyString as P, isNumber as X, isString as $ } from "@sniptt/guards";
import { memo as z, useRef as B, useState as H } from "react";
import { Tooltip as p } from "@base-ui/react/tooltip";
import { useRender as q } from "@base-ui/react/use-render";
var G = "_positioner_1oxtt_1", J = "_popup_1oxtt_5", K = "_content_1oxtt_29", Q = "_title_1oxtt_35", V = "_icon_1oxtt_47", Y = "_description_1oxtt_57", Z = "_arrow_1oxtt_63", _ = {
  positioner: G,
  popup: J,
  content: K,
  title: Q,
  icon: V,
  description: Y,
  arrow: Z
}, A = ({ children: t, description: o, startIcon: e, className: l, render: a, ref: s, ...d }) => q({
  defaultTagName: "div",
  render: a,
  ref: s,
  props: {
    ...d,
    className: R(_.content, l),
    children: /* @__PURE__ */ N(M, { children: [c(t) && t !== "" && /* @__PURE__ */ N("div", {
      className: _.title,
      children: [c(e) && /* @__PURE__ */ r("span", {
        className: _.icon,
        "aria-hidden": !0,
        children: e
      }), /* @__PURE__ */ r("span", { children: t })]
    }), c(o) && /* @__PURE__ */ r("div", {
      className: _.description,
      children: o
    })] })
  }
}), ee = 10, te = "300px", L = ({ side: t = "top", align: o = "center", sideOffset: e = ee, alignOffset: l, anchor: a, positionMethod: s, collisionBoundary: d, collisionPadding: m, collisionAvoidance: g, sticky: f, disableAnchorTracking: u, arrow: T = !1, maxWidth: w = te, container: O, keepMounted: h, className: x, children: i, ...D }) => {
  const E = j(), C = $(i) || X(i);
  return /* @__PURE__ */ r(p.Portal, {
    container: O ?? E ?? void 0,
    keepMounted: h,
    children: /* @__PURE__ */ r(p.Positioner, {
      side: t,
      align: o,
      sideOffset: e,
      alignOffset: l,
      anchor: a,
      positionMethod: s,
      collisionBoundary: d,
      collisionPadding: m,
      collisionAvoidance: g,
      sticky: f,
      disableAnchorTracking: u,
      className: _.positioner,
      style: { maxWidth: w },
      children: /* @__PURE__ */ N(p.Popup, {
        role: "tooltip",
        ...D,
        className: U(_.popup, x),
        children: [C ? /* @__PURE__ */ r(A, { children: i }) : i, T && /* @__PURE__ */ r(p.Arrow, { className: _.arrow })]
      })
    })
  });
}, oe = ({ content: t, children: o, open: e, defaultOpen: l, onOpenChange: a, onOpenChangeComplete: s, disabled: d = !1, disableHoverablePopup: m, trackCursorAxis: g, actionsRef: f, triggerId: u, defaultTriggerId: T, delay: w, closeDelay: O, closeOnClick: h, ...x }) => {
  const i = d || !c(t) || t === "" || t === !1;
  return /* @__PURE__ */ N(p.Root, {
    open: c(e) ? e && !i : void 0,
    defaultOpen: l && !i,
    onOpenChange: a,
    onOpenChangeComplete: s,
    disabled: i,
    disableHoverablePopup: m,
    trackCursorAxis: g,
    actionsRef: f,
    triggerId: u,
    defaultTriggerId: T,
    children: [/* @__PURE__ */ r(p.Trigger, {
      render: o,
      delay: w,
      closeDelay: O,
      closeOnClick: h
    }), /* @__PURE__ */ r(L, {
      ...x,
      children: t
    })]
  });
}, b = Object.assign(oe, {
  Root: p.Root,
  Trigger: p.Trigger,
  Popup: L,
  Content: A,
  Provider: p.Provider,
  createHandle: p.createHandle
}), re = "_truncate_1x6ii_1", ie = "_lineClamp_1x6ii_7", I = {
  truncate: re,
  lineClamp: ie
}, ne = ({ render: t, truncate: o, lineClamp: e, className: l, style: a, ref: s, ...d }) => {
  const m = c(e) && Number.isInteger(e) && e > 0;
  return q({
    render: t,
    ref: s,
    props: {
      ...d,
      className: R(o && I.truncate, m && I.lineClamp, l),
      style: m ? {
        ...a,
        "--text-line-clamp": e
      } : a
    }
  });
}, le = "_link_mrld0_1", ae = { link: le }, se = ({ text: t }) => P(t) ? /* @__PURE__ */ r(M, { children: F(t).map((o, e) => o.type === "link" ? /* @__PURE__ */ r("a", {
  className: ae.link,
  href: y(o.content),
  target: "_blank",
  rel: "noopener noreferrer",
  onClick: (l) => l.stopPropagation(),
  children: o.content
}, e) : o.content) }) : null, ce = "_overflowingMultilineText_1qcnw_1", pe = "_overflowingText_1qcnw_20", de = "_large_1qcnw_37", me = "_multilineTooltip_1qcnw_41", k = {
  overflowingMultilineText: ce,
  overflowingText: pe,
  large: de,
  multilineTooltip: me
}, Ce = z(function({ size: o = "small", text: e, isTooltipMultiline: l, displayedMaxRows: a, tooltipContent: s, tooltipDelay: d = 500, tooltipPlace: m = "bottom", alwaysShowTooltip: g = !1, isFocusable: f = !1 }) {
  const u = B(null), [T, w] = H(!1), [O, h] = H(!1), x = () => {
    const n = u.current, v = c(n) && (n.scrollHeight > n.clientHeight || n.scrollWidth > n.clientWidth);
    return w(v), v;
  }, i = (n) => {
    if (!n) {
      h(!1);
      return;
    }
    const v = x();
    h(v || g);
  }, D = () => {
    u.current?.focus(), i(!0);
  }, E = (n) => {
    n.stopPropagation(), n.preventDefault();
  }, C = P(s) ? s : P(e) ? e : null, S = c(a);
  return /* @__PURE__ */ N(b.Root, {
    open: O && c(C),
    onOpenChange: (...n) => {
      const [v, W] = n;
      if (!v && W.reason === "trigger-hover" && f && document.activeElement === u.current) {
        W.cancel();
        return;
      }
      i(v);
    },
    disabled: !c(C) || !T && !g,
    children: [/* @__PURE__ */ r(b.Trigger, {
      delay: d,
      closeOnClick: !1,
      render: /* @__PURE__ */ r(ne, {
        ...S ? { lineClamp: a || 1 } : { truncate: !0 },
        "data-testid": "tooltip",
        "data-content-overflowing": T ? "" : void 0,
        className: R(S ? k.overflowingMultilineText : k.overflowingText, o === "large" && k.large),
        ref: u,
        tabIndex: f ? 0 : void 0,
        onPointerEnter: x,
        onFocus: f ? () => i(!0) : void 0,
        onClick: f ? D : void 0,
        children: P(e) ? /* @__PURE__ */ r(se, { text: e }) : e
      })
    }), /* @__PURE__ */ r(b.Popup, {
      className: l ? k.multilineTooltip : void 0,
      sideOffset: 5,
      side: m,
      positionMethod: "absolute",
      onClick: E,
      children: C
    })]
  });
});
export {
  ne as n,
  b as r,
  Ce as t
};
